import { render } from "./homeHead.vue?vue&type=template&id=67ba11d5&scoped=true"
import script from "./homeHead.vue?vue&type=script&lang=js"
export * from "./homeHead.vue?vue&type=script&lang=js"

import "./homeHead.vue?vue&type=style&index=0&id=67ba11d5&scoped=true&lang=scss"

import exportComponent from "E:\\edu-ui\\BmMuseumAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67ba11d5"]])

export default __exports__